import { render, staticRenderFns } from "./MaterialStageOld.vue?vue&type=template&id=5a6f4948"
import script from "./MaterialStageOld.vue?vue&type=script&lang=js"
export * from "./MaterialStageOld.vue?vue&type=script&lang=js"
import style0 from "./MaterialStageOld.vue?vue&type=style&index=0&id=5a6f4948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports